import { useT } from '../lib/i18n.js';
import { useUpdateAvailable } from '../lib/version.js';

/**
 * "A new version of hamro.school is available."
 *
 * Deliberately not automatic. Reloading underneath someone mid-register would
 * lose a period of work, so the choice is theirs and the dismissal sticks until
 * the *next* release. It sits above the bottom tab bar on a phone and bottom
 * right on a laptop, the same geometry as a toast — the one place in this
 * product where transient things appear.
 *
 * `role="status"` rather than `alert`: worth announcing, never worth
 * interrupting.
 */
export function UpdateBanner() {
  const t = useT();
  const { available, dismiss } = useUpdateAvailable();

  if (!available) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-20 left-1/2 z-40 w-[min(420px,calc(100vw-2rem))] -translate-x-1/2 rounded-[3px] border border-ink bg-ink px-4 py-3 text-paper shadow-[3px_3px_0_rgb(20_36_60_/_0.25)] lg:bottom-6 lg:left-auto lg:right-6 lg:translate-x-0"
    >
      <div className="font-mono text-[10px] tracking-[0.14em] text-marigold uppercase">
        {t('app.update.kicker')}
      </div>
      <div className="mt-0.5 text-[14px]">{t('app.update.detail')}</div>

      <div className="mt-2.5 flex items-center gap-2">
        <button
          type="button"
          // A plain reload: the browser fetches the new index.html and with it
          // the new bundle. Nothing here needs to know how deploys work.
          onClick={() => window.location.reload()}
          className="rounded-[3px] border-[1.5px] border-paper bg-paper px-3 py-1.5 font-display text-[13px] font-semibold text-ink"
        >
          {t('app.update.reload')}
        </button>
        <button
          type="button"
          onClick={dismiss}
          className="rounded-[3px] px-2 py-1.5 font-display text-[13px] text-paper/70 hover:text-paper"
        >
          {t('app.update.later')}
        </button>
      </div>
    </div>
  );
}
